import { setSession } from '@back-office/core';
import {
  LoginResponse,
  postRegister,
  RegisterRequest,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { Self } from '../common';

function* registerRequest(
  self: Self,
  body: RegisterRequest
): Generator<Promise<FlowReturn<LoginResponse>>> {
  self.isLoading = true;
  try {
    const response = yield postRegister(body);
    const { data, status } = (response as LoginResponse).data;
    if (status.code === 1000) {
      setSession({ users: data.mids });
      return Promise.resolve(data);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default registerRequest;
